import React, { useState, useEffect, useRef } from 'react';

import classNames from 'classnames';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import '../../../components/Crud.scss';
import * as _ from 'lodash';
import { ProgressBar } from 'primereact/progressbar';
import { v4 as uuidv4 } from 'uuid';
import {Checkbox} from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { Paginator } from 'primereact/paginator';
import { PickList } from 'primereact/picklist';

import { SubscriptionService } from '../services/SubscriptionService';
import { SubscriptionPlanService } from '../services/SubscriptionPlanService';
import { EntityService } from "../../../service/EntityService";
import { LanguageService } from "../../../service/LanguageService";
import { Fieldset } from 'primereact/fieldset';
import { InputMask } from 'primereact/inputmask';
import { SelectButton } from 'primereact/selectbutton';
import { AuthorizationService } from '../../../service/AuthorizationService';
import { FileService } from '../../../service/FileService';

import { useMercadopago } from 'react-sdk-mercadopago';
import { useLocation } from "react-router-dom";

import { Galleria } from 'primereact/galleria';

function ViewSubscriptions() {

    const subscriptionService = new SubscriptionService();
    const subscriptionPlanService = new SubscriptionPlanService();
    const languageService = new LanguageService();
    const authorizationService = new AuthorizationService();
    const fileService = new FileService();

    const [currentSubscriptions, setCurrentSubscriptions] = useState(null);
    const [subscriptionPlans, setSubscriptionPlans] = useState([]);
    const [currentCustomer, setCurrentCustomer] = useState({ client_id: authorizationService.getCurrentUser().client.id, type: "PJ", address: {}});
    const [tenant, setTenant] = useState(authorizationService.getCurrentUser().client);
    
    const [loading, setLoading] = useState(true);
    const [showDetails, setShowDetails] = useState(false);
    const [itemToDetail, setItemToDetail] = useState({ config: {}});

    const [showCustomerCreation, setShowCustomerCreation] = useState(false);
    const [saving, setSaving] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const [showSubscriptionConfirmation, setShowSubscriptionConfirmation] = useState(false);
    const [showPaymentScreen, setShowPaymentScreen] = useState(false);
    const [subscriptionEnded, setSubscriptionEnded] = useState(false);

    const toast = useRef(null);

    const [thumbnails, setThumbnails] = useState([]);
    const [fullScreenGalleria, setFullScreenGalleria] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);

    const search = useLocation().search;

    useEffect(() => {

        async function fetchData() {

            setCurrentCustomer(Object.assign(currentCustomer, await subscriptionService.getCurrentCustomer()));
            setCurrentSubscriptions(await subscriptionService.getCurrentSubscriptions());
            const plans = ((await subscriptionPlanService.listAll()).items || []).filter(p => !p.config.disabled);
            setSubscriptionPlans(plans);

            let imagesToLoad = plans.map(p => [p.config.thumbnail].concat(p.config.images || []));
            
            setThumbnails(await fileService.listAll(imagesToLoad));

            const planToOpen = new URLSearchParams(search).get('p') || "";

            if(planToOpen !== "" && plans.find(p => p.id === planToOpen)){
                openPlan(plans.find(p => p.id === planToOpen)); 
            }

            const client = authorizationService.getCurrentUser().client;
            if((client.config.payment_methods || {}).credit_card){
                setPaymentMethod('credit_card');
            }

            setLoading(false);
        }        
        fetchData();

        const mercadoPagoIframeMessageshandler = async event => {
            const data = event.data;
            if(data.message && data.message.source === "mercadopagoiframe"){
                if(data.message.command === "token"){
                    console.log("temos os tokens", data);
                    console.log("payment method", paymentMethod);  
                    await doSubscribe(data.message.planId, data.message.tokens, data.message.deviceId, paymentMethod); 
                }
                else if(data.message.command === "pending_data"){
                    toast.current.show({ severity: 'warn', summary: 'Dados Invalidos', detail: "Por favor preencha todos os dados", sticky: false, life: 3000 });
                    setSaving(false);
                }
                else if(data.message.command === "error"){
                    toast.current.show({ severity: 'error', summary: 'Oops. Ocorreu um erro', detail: data.message.errorMessage, sticky: false, life: 3000 });
                    setSaving(false);
                }
            }
            
          }
      
          window.addEventListener("message", mercadoPagoIframeMessageshandler)
      
          // clean up
          return () => window.removeEventListener("message", mercadoPagoIframeMessageshandler)

    }, []);

    const isValidData = () => {
        return (currentCustomer.name || "") !== ""
            && (currentCustomer.type || "") !== ""
            && (currentCustomer.registration_number || "") !== ""
            && (currentCustomer.address.street || "") !== ""
            && (currentCustomer.address.number || "") !== ""
            && (currentCustomer.address.complement || "") !== ""
            && (currentCustomer.address.city || "") !== ""
            && (currentCustomer.address.state || "") !== ""
            && (currentCustomer.address.zipcode || "") !== "";
    }

    const doSubscribe = async (planId, tokens, deviceId, _paymentMethod) => {
        console.log("doSubscribe");
        console.log("planId", planId);
        console.log("tokens", tokens);
        console.log("deviceId", deviceId);
        console.log("_paymentMethod", _paymentMethod);
        
        try {
            setSaving(true);
            await subscriptionService.subscribe(planId, tokens, deviceId, _paymentMethod);
            setCurrentSubscriptions(await subscriptionService.getCurrentSubscriptions());
            setSaving(false);
            setShowSubscriptionConfirmation(false);
            setSubscriptionEnded(true);
        } catch (error) {
            console.log(error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.toString(), sticky: true });
            setSaving(false);
        }
    }

    const [paymentMethod, setPaymentMethod] = useState('offline');
    const subscribe = async (plan) => {

        if(currentSubscriptions.find(s => s.config.status === "WAITING_PAYMENT" )){
            toast.current.show({ severity: 'warn', summary: 'Pagamento Pendente', detail: "Você possui uma assinatura aguardando pagamento. Para assinar um novo plano, primeiro cancele a assinatura pendente.", sticky: false, life: 30000 });
        }
        else {
            if(showCustomerCreation)
            {
                setSaving(true);
                if(showSubscriptionConfirmation)
                {
                    if(showPaymentScreen)
                    {
                        console.log(window.document.getElementById("mercadoPagoIframe").contentWindow);
                        window.document.getElementById("mercadoPagoIframe").contentWindow.postMessage({ 
                            command: "submit",
                            document_type: currentCustomer.type === "PJ" ? "CNPJ" : "CPF",
                            document: currentCustomer.registration_number,
                            email: currentCustomer.email,
                            planId: itemToDetail.id
                        });
                    }
                    else 
                    {
                        if(paymentMethod === 'credit_card'){
                            setShowPaymentScreen(true);
                        }
                        else {
                            await doSubscribe(itemToDetail.id, null, null, paymentMethod);
                        }

                        setSaving(false);
                    }
                    
                }
                else {
                    setSubmitted(true);
                    if(isValidData()){
                        setSaving(true);
                        try {
                            const _customer = await subscriptionService.saveCurrentCustomer(currentCustomer);
                            setCurrentCustomer(_customer);
                            setShowSubscriptionConfirmation(true);
                            setSaving(false);
                        } catch (error) {
                            toast.current.show({ severity: 'error', summary: 'Error', detail: error.toString(), sticky: true });
                            console.log(error);
                        }
                    }
                }
                
            }
            else {
                setShowCustomerCreation(true);
            }
            
            //setSaving(false);
        }
    }

    const onCustomerChange = (properyValue, propertyName) => {
        let _currentCustomer = { ...currentCustomer };
        _.set(_currentCustomer, propertyName, properyValue);
        setCurrentCustomer(_currentCustomer);
    }

    const closeDialog = () => {
        if(subscriptionEnded){
            const client = authorizationService.getCurrentUser().client;
            window.location.href = `${client && !client.use_custom_url ? `/${client.shortcode}` : ''}`;
        }
        else {
            setShowDetails(false)
            setShowCustomerCreation(false);
            setShowSubscriptionConfirmation(false);
        }
        
    }

    const openPlan = (plan) => {
        setItemToDetail(plan); 
    }

    const goToSubscribe = (plan) => {

        if(plan.config.external_checkout && (plan.config.external_checkout_url || "") !== "") {
            window.open(plan.config.external_checkout_url, '_blank');
        }
        else
        { 
            setShowCustomerCreation(true); 
            setShowDetails(true)
        }
    }

    const client = authorizationService.getCurrentUser().client;

    return (
        <div className="datatable-crud-demo subscriptions">
            
            <Toast ref={toast} />
            { loading && <div className="card"><ProgressBar mode="indeterminate"/> </div> }
            
            { !loading && <div>
                
                { itemToDetail.id && <div className='card' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around', padding: '20px'}}>
                    <div style={{ display: 'flex', flexDirection: 'row'}}>
                        { ((itemToDetail.config.images || []).length > 0 || (itemToDetail.config.video || "") !== "") && 
                        <div style={{ display: 'flex', flexDirection: 'column', width: '40%', minWidth: '500px', marginRight: '50px'}}>
                        <Galleria 
                        circular
                            activeIndex={activeIndex} onItemChange={(e) => setActiveIndex(e.index)}
                            value={(itemToDetail.config.video || "") !== "" ? [itemToDetail.config.video].concat(itemToDetail.config.images || []) : (itemToDetail.config.images || [])} 
                            item={ (i) =>  
                                <div style={{ position: 'relative'}}>
                                    { i.startsWith("http") ?
                                        <iframe id={`plan_video_${itemToDetail.id}`} width="500" height="315" src={i + '?controls=0'} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; controls=0;encrypted-media; gyroscope; picture-in-picture" allowFullScreen/>
                                        : <img src={((thumbnails || []).find(f => f.id === i) || {}).content} style={{width: '100%', maxWidth: '500px'}}/> 
                                    }
                                    <div style={{ position: 'absolute', cursor: 'pointer', top: "0px", left: "0px", width: '100%', height: '100%', 
                                        zIndex: 1000,
                                        display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', padding: '20px'}}
                                        onClick={() => fullScreenGalleria.show()}
                                        >
                                            <div style={{backgroundColor: '#fff', padding: 6, borderRadius: 6}}><i className="pi pi-window-maximize" style={{'fontSize': '2em', color: client.custom_layout.primaryButtonColor}}></i></div>
                                    </div>
                                </div>
                                } 
                            thumbnail={(i) => i.startsWith("http") ? <i className="pi pi-video" style={{'fontSize': '2em', border: '1px solid black', borderRadius: '5px', padding: '20px'}}></i> : <img src={((thumbnails || []).find(f => f.id === i) || {}).content} style={{height: '80px'}}/>}>
                        </Galleria>
                        <Galleria ref={(el) =>setFullScreenGalleria(el)} 
                            activeIndex={activeIndex} onItemChange={(e) => setActiveIndex(e.index)}
                            fullScreen showItemNavigators showThumbnails={false} circular
                            value={(itemToDetail.config.video || "") !== "" ? [itemToDetail.config.video].concat(itemToDetail.config.images || []) : (itemToDetail.config.images || [])} 
                            item={ (i) => i.startsWith("http") ?  
                                <div>
                                    <iframe id={`plan_video_${itemToDetail.id}`} width="1120" height="630" src={i} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; controls=0;encrypted-media; gyroscope; picture-in-picture" allowFullScreen/>
                                </div>
                                : <img src={((thumbnails || []).find(f => f.id === i) || {}).content} style={{width: '100%', maxWidth: '500px'}}/>} 
                            thumbnail={(i) => i.startsWith("http") ? <i className="pi pi-video" style={{'fontSize': '2em', border: '1px solid black', borderRadius: '5px', padding: '20px'}}></i> : <img src={((thumbnails || []).find(f => f.id === i) || {}).content} style={{height: '80px'}}/>}>
                        </Galleria>
 
                        </div>}
                        <div style={{ display: 'flex', flex: 1, flexDirection: 'column'}}>
                            <div style={{ fontSize: '36px', marginBottom: '40px', fontWeight: 'bold'}}>{ itemToDetail.name }</div>
                            <div style={{ fontSize: '18px', marginBottom: '40px'}} dangerouslySetInnerHTML={{ __html: itemToDetail.config.summary}}></div>
                            { (itemToDetail.config || {}).has_expiration &&
                            <div style={{ fontSize: '24px', marginBottom: '40px'}}>
                                <b>Prazo</b><br/>
                                {itemToDetail.config.expiration_in_months} meses
                            </div>
                            }
                            { (itemToDetail.config.setup_fee || {}).active && <>
                            <div style={{ fontSize: '24px', marginBottom: '40px'}}>
                                <b>{(itemToDetail.config.setup_fee || {}).label}</b><br/>
                                {parseFloat("" + (itemToDetail.config.setup_fee || {}).price).toLocaleString('pt-BR',{minimumFractionDigits: 2, style: 'currency', currency: 'BRL'})}
                            </div>
                            </>}
                            { (itemToDetail.config.recurring_fee || {}).active && <>
                            <div style={{ fontSize: '24px', marginBottom: '40px'}}>
                                <b>{(itemToDetail.config.recurring_fee || {}).label}</b><br/>
                                {parseFloat("" + (itemToDetail.config.recurring_fee || {}).price).toLocaleString('pt-BR',{minimumFractionDigits: 2, style: 'currency', currency: 'BRL'})}
                            </div>
                            </>}
                            <div style={{textAlign: 'center', display: 'flex', flexDirection: 'row', justifyContent: 'space-around'}}>
                                <Button label={"Assinar"} icon="pi pi-check" className="p-button" style={{ fontSize: '28px', backgroundColor: client.custom_layout.primaryButtonColor, borderColor: client.custom_layout.primaryButtonColor}} onClick={() => goToSubscribe(itemToDetail)} />
                                <Button label={"Voltar"} icon="pi pi-angle-left" className="p-button" style={{ fontSize: '28px', backgroundColor: client.custom_layout.secondaryBackgroundColor, borderColor: client.custom_layout.secondaryBackgroundColor}} onClick={() => { setItemToDetail({config:{}})}} />
                            </div>
                        </div>
                    </div>
                    <div>
                        <div style={{ fontSize: '24px', marginBottom: '20px', padding: '20px', fontWeight: 'bold'}}>Sobre o Plano</div>
                        <div style={{ fontSize: '18px', padding: '20px'}} dangerouslySetInnerHTML={{ __html: itemToDetail.config.description}}></div>
                    </div>
                   
                </div>}

                { !itemToDetail.id && 
                    <div className='card' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around'}}>
                    {
                        subscriptionPlans.map(plan => 
                            <div key={`plan${plan.id}`} className="card summary" style={{
                                border: '1px solid #eee', 
                                margin: '10px', 
                                maxWidth: '400px',
                                marginBottom: '10px', display: 'flex', flexDirection: 'column', padding: '30px', justifyContent: 'flex-start', alignItems: 'center'}}>
                                <div style={{ fontSize: '24px', marginBottom: '20px'}}><b>{plan.name}</b></div>
                                <div style={{ fontSize: '24px', marginBottom: '20px'}}>
                                    <img src={((thumbnails || []).find(f => f.id === plan.config.thumbnail) || {}).content} style={{width: '100%', maxWidth: '200px'}}/>    
                                </div>
                                <div style={{ fontSize: '16px', marginBottom: '20px'}} className="" dangerouslySetInnerHTML={{ __html: plan.config.summary || ""}}></div>
                                { (plan.config || {}).has_expiration &&
                                <div style={{ fontSize: '24px', marginBottom: '20px', textAlign:'center'}}>
                                    <b>Prazo</b><br/>
                                    {(plan.config || {}).expiration_in_months} meses
                                </div>
                                }
                                { (plan.config.setup_fee || {}).active && <>
                                <div style={{ fontSize: '24px', marginBottom: '20px', textAlign:'center'}}>
                                    <b>{(plan.config.setup_fee || {}).label}</b><br/>
                                    {parseFloat("" + (plan.config.setup_fee || {}).price).toLocaleString('pt-BR',{minimumFractionDigits: 2, style: 'currency', currency: 'BRL'})}
                                </div>
                                </>}
                                { (plan.config.recurring_fee || {}).active && <>
                                <div style={{ fontSize: '24px', marginBottom: '20px', textAlign:'center'}}>
                                    <b>{(plan.config.recurring_fee || {}).label}</b><br/>
                                    {parseFloat("" + (plan.config.recurring_fee || {}).price).toLocaleString('pt-BR',{minimumFractionDigits: 2, style: 'currency', currency: 'BRL'})}
                                </div>
                                </>}
                                <div style={{textAlign: 'right'}}>
                                    <Button label={"Mais Detalhes"} icon="pi pi-eye" className="p-button" style={{ backgroundColor: client.custom_layout.primaryButtonColor, borderColor: client.custom_layout.primaryButtonColor}} onClick={() => { openPlan(plan)}} />
                                </div>
                            </div>  
                        )
                    }
                    </div>
                }

                
            </div>   }
            
            { showDetails &&
                <Dialog 
                    visible={true} 
                    style={{ width: '80vw' }} 
                    header={showCustomerCreation ? `${currentCustomer.id ? "Confirmar " : ""}${ showSubscriptionConfirmation ? "Assinatura" : "Dados de Faturamento"}` : itemToDetail.name}
                    modal 
                    className="p-fluid" 
                    footer={<>
                        { saving && <ProgressSpinner style={{width: '20px', height: '20px'}} strokeWidth="8"/> }
                        { showSubscriptionConfirmation && <Button disabled={saving} label={"Voltar" } icon={ "pi pi-angle-double-left" } className="p-button-text" onClick={() => { setShowSubscriptionConfirmation(false); setShowPaymentScreen(false) }} />}
                        { !subscriptionEnded && <Button disabled={saving} label={showCustomerCreation ? showSubscriptionConfirmation ? "Confirmar" : 'Continuar' : "Assinar" } icon={!showCustomerCreation ? "pi pi-check" : "pi pi-angle-double-right" } className="p-button-text" onClick={() => subscribe(itemToDetail)} />}
                        <Button disabled={saving} label={"Fechar"} icon="pi pi-times" className="p-button-text" onClick={() => closeDialog()} />
                    </>} 
                    onHide={() => closeDialog()}>
                        { subscriptionEnded ?
                            <>
                                <div className="card summary p-grid">
                                    <div className="p-col-12">{authorizationService.getCurrentUser().client.config.subscription_feedback}</div>
                                </div>
                            </>
                            :
                            <>
                            { !showCustomerCreation && !showSubscriptionConfirmation &&
                                <>
                                    <div className="card summary p-grid">
                                        <div className="p-col-12" dangerouslySetInnerHTML={{ __html: itemToDetail.config.summary}}></div>
                                        { (itemToDetail.config.setup_fee || {}).active && <>
                                        <div className="p-col-12" style={{textAlign: 'left'}}>
                                            <b>{ (itemToDetail.config.setup_fee || {}).label}</b><br/>
                                            {parseFloat("" + (itemToDetail.config.setup_fee || {}).price).toLocaleString('pt-BR',{minimumFractionDigits: 2, style: 'currency', currency: 'BRL'})}
                                        </div>
                                        </>}
                                        { (itemToDetail.config.recurring_fee || {}).active && <>
                                        <div className="p-col-12" style={{textAlign: 'left'}}>
                                            <b>{ (itemToDetail.config.recurring_fee || {}).label}</b><br/>
                                            {parseFloat("" + (itemToDetail.config.recurring_fee || {}).price).toLocaleString('pt-BR',{minimumFractionDigits: 2, style: 'currency', currency: 'BRL'})} por {(itemToDetail.config.recurring_fee || {}).expiration_in_months} meses
                                        </div>
                                        </>}
                                    </div>
                                </>
                            }
                            { showCustomerCreation && !showSubscriptionConfirmation &&
                                <div className="card summary">
                                    <div className="p-formgrid p-grid">
                                        <div className="p-field p-col-3">
                                            <label htmlFor="name">Nome*</label>
                                            <InputText disabled={saving} id="name" value={currentCustomer.name || ""} onChange={(e) => onCustomerChange(e.target.value, 'name')} required autoFocus className={classNames({ 'p-invalid': submitted && !currentCustomer.name })} />
                                            { submitted && (currentCustomer.name || "") === "" && <small className="p-invalid">Campo obrigatório.</small>}
                                        </div>
                                        <div className="p-field p-col-3">
                                            <label htmlFor="email">Email*</label>
                                            <InputText disabled={saving} id="name" value={currentCustomer.email || ""} onChange={(e) => onCustomerChange(e.target.value, 'email')} required autoFocus className={classNames({ 'p-invalid': submitted && !currentCustomer.email })} />
                                            { submitted && (currentCustomer.email || "") === "" && <small className="p-invalid">Campo obrigatório.</small>}
                                        </div>
                                        <div className="p-field p-col-3">
                                            <label htmlFor="type">Pessoa*</label>
                                            <SelectButton disabled={saving} id="type" value={currentCustomer.type || ""} options={[{label: 'Jurídica', value: 'PJ'},{label: 'Física', value: 'PF'}]} onChange={(e) => onCustomerChange(e.value, 'type')}></SelectButton>
                                            { submitted && (currentCustomer.type || "") === "" && <small className="p-invalid">Campo obrigatório.</small>}
                                        </div>
                                        <div className="p-field p-col-3">
                                            <label htmlFor="registration_number">{languageService.getText("Registration_Number")}*</label>
                                            <InputMask disabled={saving} autoClear={false} mask={ currentCustomer.type === "PJ" ? "99.999.999-9999/99" : "999.999.999-99" } value={currentCustomer.registration_number || ""} placeholder={ currentCustomer.type === "PJ" ? "__.___.___-____/__" : "___.___.___-__" } unmask={true} onChange={(e) => onCustomerChange(e.value.replace(/\D/g,''), 'registration_number')} className={classNames({ 'p-invalid': submitted && !currentCustomer.registration_number })} ></InputMask>
                                            { submitted && (currentCustomer.registration_number || "") === "" && <small className="p-invalid">Campo obrigatório.</small>}
                                        </div>
                                        <Fieldset legend={languageService.getText("Address")}>
                                            <div className="p-grid">
                                                <div className="p-field p-col-4">
                                                    <label htmlFor="street">{languageService.getText("Street")}</label>
                                                    <InputText disabled={saving} id="street" value={currentCustomer.address.street || ""} onChange={(e) => onCustomerChange(e.target.value, 'address.street')} className={classNames({ 'p-invalid': submitted && !currentCustomer.address.street })} />
                                                    { submitted && (currentCustomer.address.street || "") === "" && <small className="p-invalid">Campo obrigatório.</small>}
                                                </div>
                                                <div className="p-field p-col-4">
                                                    <label htmlFor="number">{languageService.getText("Number")}</label>
                                                    <InputText disabled={saving} id="number" value={currentCustomer.address.number || ""} onChange={(e) => onCustomerChange(e.target.value, 'address.number')} className={classNames({ 'p-invalid': submitted && !currentCustomer.address.number })} />
                                                    { submitted && (currentCustomer.address.number || "") === "" && <small className="p-invalid">Campo obrigatório.</small>}
                                                </div>
                                                <div className="p-field p-col-4">
                                                    <label htmlFor="complement">{languageService.getText("Complement")}</label>
                                                    <InputText disabled={saving} id="complement" value={currentCustomer.address.complement || ""} onChange={(e) => onCustomerChange(e.target.value, 'address.complement')} className={classNames({ 'p-invalid': submitted && !currentCustomer.address.complement })} />
                                                    { submitted && (currentCustomer.address.complement || "") === "" && <small className="p-invalid">Campo obrigatório.</small>}
                                                </div>
                                                <div className="p-field p-col-4">
                                                    <label htmlFor="city">{languageService.getText("City")}</label>
                                                    <InputText disabled={saving} id="city" value={currentCustomer.address.city || ""} onChange={(e) => onCustomerChange(e.target.value, 'address.city')} className={classNames({ 'p-invalid': submitted && !currentCustomer.address.city })} />
                                                    { submitted && (currentCustomer.address.city || "") === "" && <small className="p-invalid">Campo obrigatório.</small>}
                                                </div>
                                                <div className="p-field p-col-4">
                                                    <label htmlFor="state">{languageService.getText("State")}</label>
                                                    <InputText disabled={saving} id="state" value={currentCustomer.address.state || ""} onChange={(e) => onCustomerChange(e.target.value, 'address.state')} className={classNames({ 'p-invalid': submitted && !currentCustomer.address.state })} />
                                                    { submitted && (currentCustomer.address.state || "") === "" && <small className="p-invalid">Campo obrigatório.</small>}
                                                </div>
                                                <div className="p-field p-col-4">
                                                    <label htmlFor="zipcode">{languageService.getText("ZipCode")}</label>
                                                    <InputText disabled={saving} id="zipcode" value={currentCustomer.address.zipcode || ""} onChange={(e) => onCustomerChange(e.target.value, 'address.zipcode')} className={classNames({ 'p-invalid': submitted && !currentCustomer.address.zipcode })} />
                                                    { submitted && (currentCustomer.address.zipcode || "") === "" && <small className="p-invalid">Campo obrigatório.</small>}
                                                </div>
                                            </div>
                                        </Fieldset>
                                        { (client.config.payment_methods || {}).offline && (client.config.payment_methods || {}).credit_card && 
                                        <Fieldset legend={languageService.getText("Metodo de Pagamento")} style={{width: '100%'}}>
                                            <div className="p-grid">
                                                <div className="p-field p-col-12">
                                                <SelectButton disabled={saving} id="type" value={paymentMethod} options={[{label: 'Boleto', value: 'offline'},{label: 'Cartão de Crédito', value: 'credit_card'}]} onChange={(e) => setPaymentMethod(e.value)}></SelectButton>
                                                </div>
                                            </div>
                                        </Fieldset>
                                        }
                                    </div>
                                `</div>
                            }    
                            { showSubscriptionConfirmation && !showPaymentScreen && <>
                                <Fieldset legend={"Prazo e Pagamentos"}>
                                    <div className="p-grid">
                                        <div className="p-col-12"><b>{itemToDetail.name}</b></div>
                                        <div className="p-col-12" dangerouslySetInnerHTML={{ __html: itemToDetail.config.summary}}></div>
                                        <div className="p-col-4" style={{textAlign: 'left'}}>
                                            <b>Prazo</b><br/>
                                            {(itemToDetail.config || {}).has_expiration && <>
                                            {(itemToDetail.config || {}).expiration_in_months} meses
                                            </>}
                                            {!(itemToDetail.config || {}).has_expiration && <>
                                            Sem prazo
                                            </>}
                                        </div>
                                        { (itemToDetail.config.setup_fee || {}).active && <>
                                        <div className="p-col-4" style={{textAlign: 'left'}}>
                                            <b>{ (itemToDetail.config.setup_fee || {}).label}</b><br/>
                                            {parseFloat("" + (itemToDetail.config.setup_fee || {}).price).toLocaleString('pt-BR',{minimumFractionDigits: 2, style: 'currency', currency: 'BRL'})}
                                        </div>
                                        </>}
                                        { (itemToDetail.config.recurring_fee || {}).active && <>
                                        <div className="p-col-4" style={{textAlign: 'left'}}>
                                            <b>{ (itemToDetail.config.recurring_fee || {}).label}</b><br/>
                                            {parseFloat("" + (itemToDetail.config.recurring_fee || {}).price).toLocaleString('pt-BR',{minimumFractionDigits: 2, style: 'currency', currency: 'BRL'})}
                                        </div>
                                        </>}
                                    </div>  
                                </Fieldset>
                                <Fieldset legend={"Assinante"} style={{marginTop: '10px'}}s>
                                    <div className="p-grid">
                                        <div className="p-col-4"><b>Nome</b></div>
                                        <div className="p-col-4"><b>E-mail</b></div>
                                        <div className="p-col-4"><b>{currentCustomer.type === "PJ" ? "CNPJ" : "CPF"}</b></div>
                                        <div className="p-col-4">{currentCustomer.name}</div>
                                        <div className="p-col-4">{currentCustomer.email}</div>
                                        <div className="p-col-4">{currentCustomer.registration_number}</div>
                                    </div>
                                </Fieldset>
                                <Fieldset legend={languageService.getText("Address")} style={{marginTop: '10px'}}>
                                    <div className="p-grid">
                                        <div className="p-col-4"><b>{languageService.getText("Street")}</b></div>
                                        <div className="p-col-4"><b>{languageService.getText("Number")}</b></div>
                                        <div className="p-col-4"><b>{languageService.getText("Complement")}</b></div>
                                        <div className="p-col-4">{currentCustomer.address.street || ""}</div>
                                        <div className="p-col-4">{currentCustomer.address.number || ""}</div>
                                        <div className="p-col-4">{currentCustomer.address.complement || ""}</div>
                                        <div className="p-col-4"><b>{languageService.getText("City")}</b></div>
                                        <div className="p-col-4"><b>{languageService.getText("State")}</b></div>
                                        <div className="p-col-4"><b>{languageService.getText("ZipCode")}</b></div>
                                        <div className="p-col-4">{currentCustomer.address.city || ""}</div>
                                        <div className="p-col-4">{currentCustomer.address.state || ""}</div>
                                        <div className="p-col-4">{currentCustomer.address.zipcode || ""}</div>
                                    </div>
                                </Fieldset>
                                <Fieldset legend={languageService.getText("Metodo de Pagamento")} style={{width: '100%'}}>
                                    <div className="p-grid">
                                        <div className="p-field p-col-12">
                                        { paymentMethod === 'credit_card' ? "Cartão de Crédito" : "Boleto"}
                                        </div>
                                    </div>
                                </Fieldset>
                                </>
                            }
                            { showSubscriptionConfirmation && showPaymentScreen && 
                                <Fieldset legend={languageService.getText("Dados do Cartão")} style={{marginTop: '10px'}}>
                                    <iframe id="mercadoPagoIframe" src={`/mercadopago.html?a=${itemToDetail.config.price}&key=${authorizationService.getCurrentUser().client.config.mercadopago_public_key}`} style={{border: 'none', width: '600px'}}/>
                                </Fieldset>
                            }
                            </>
                        }

                </Dialog>         
            }
        </div>
    );
}

export default ViewSubscriptions;